import { Close as CloseIcon } from '@mui/icons-material'
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Typography
} from '@mui/material'
import { GreenText } from 'components'
import { VehicleDamageDetailsDto } from 'dtos'
import { useState } from 'react'
import DamagePhotoCard from './DamagePhotoCard'

interface DamagePhotosListCardProps {
  damage: VehicleDamageDetailsDto
}

export default function DamagePhotosListCard({ damage }: DamagePhotosListCardProps) {
  const [src, setSrc] = useState<string | undefined>(undefined)

  return (
    <>
      <Dialog
        open={Boolean(src)}
        onClose={() => {
          setSrc(undefined)
        }}
        fullWidth
        maxWidth='md'
      >
        <DialogTitle>
          <Grid container alignItems='center' justifyContent='space-between'>
            <Grid item>
              <Typography variant='h6'>Damage Photo</Typography>
            </Grid>

            <Grid item>
              <IconButton
                color='inherit'
                edge='end'
                onClick={() => {
                  setSrc(undefined)
                }}
                size='small'
              >
                <CloseIcon fontSize='small' />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <img src={src} alt='Damage' style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }} />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
              setSrc(undefined)
            }}
            color='primary'
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm={6}>
                <Typography fontWeight='bold' variant='h5' sx={{ mb: 1 }}>
                  Damage Photos
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider />
          </Grid>

          <Grid item container direction='column' spacing={2} alignItems='center' sx={{ mt: 1, mb: 3 }}>
            {damage.damagePhoto1FileName && (
              <Grid item xs={12}>
                <DamagePhotoCard
                  label='Damage Photo 1'
                  photoUrl={`/api/damage/${encodeURIComponent(damage.vehicleDamageGuid!)}/damage-photo/${encodeURIComponent(
                    damage.damagePhoto1FileName
                  )}`}
                  onClick={() => {
                    setSrc(
                      `/api/damage/${encodeURIComponent(damage.vehicleDamageGuid!)}/damage-photo/${encodeURIComponent(
                        damage.damagePhoto1FileName!
                      )}`
                    )
                  }}
                />
              </Grid>
            )}

            {damage.damagePhoto2FileName && (
              <Grid item xs={12}>
                <DamagePhotoCard
                  label='Damage Photo 2'
                  photoUrl={`/api/damage/${encodeURIComponent(damage.vehicleDamageGuid!)}/damage-photo/${encodeURIComponent(
                    damage.damagePhoto2FileName
                  )}`}
                  onClick={() => {
                    setSrc(
                      `/api/damage/${encodeURIComponent(damage.vehicleDamageGuid!)}/damage-photo/${encodeURIComponent(
                        damage.damagePhoto2FileName!
                      )}`
                    )
                  }}
                />
              </Grid>
            )}

            {damage.damagePhoto3FileName && (
              <Grid item xs={12}>
                <DamagePhotoCard
                  label='Damage Photo 3'
                  photoUrl={`/api/damage/${encodeURIComponent(damage.vehicleDamageGuid!)}/damage-photo/${encodeURIComponent(
                    damage.damagePhoto3FileName
                  )}`}
                  onClick={() => {
                    setSrc(
                      `/api/damage/${encodeURIComponent(damage.vehicleDamageGuid!)}/damage-photo/${encodeURIComponent(
                        damage.damagePhoto3FileName!
                      )}`
                    )
                  }}
                />
              </Grid>
            )}
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Damage Photos:** 

Displays the damage photos uploaded when the damage record was created. 

Clicking on a photo opens a larger view of the image. 

Users cannot delete uploaded damage photos. 

If fewer than three damage photos were uploaded, only the available ones will be shown.`}
            </GreenText>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
